<template>
  <div class="container-fluid">

    <!-- Modal CONFIRM -->
    <modalConfirm ref="confirmModal" />

     <!-- Modal MESSAGE -->  
    <modalMessage ref="msgModal"/>

   <div class="page-header_">

    <button @click="$emit('back')"  class="btn btn-secondary mt-2 ml-2 mb-2">
     <i style="color:yellow" class="fas fa-reply  mr-2" aria-hidden="true"></i>
        RITORNA A REGISTRAZIONE PRODOTTO
    </button>

    

    <!-- PRODUCT SIZES LIST -->
    <productSizeList  v-bind:props = "product" @update="setProductSizesList"></productSizeList>

    <div class="row">
      
      <productCollections class="ml-4" v-bind:productId="product.productId"></productCollections>

      <!-- SIZES LIST-->  
      <sizes-list v-if="refresh" v-bind:selection="sizes" @update="setSizes"></sizes-list>

      <!-- NEW COLOR -->
      <modalNewColor class="ml-4"></modalNewColor>

    </div>

    </div>
    
    
    <form   v-on:submit.prevent="submit()">
     <div class="table-responsive-sm">       
      <table class="table table-bordered table-hover table-sm mb-0 mt-4 my-table">
         <caption>Inserimento varianti colore/misura
          
    

        </caption>
        <thead class="thead-light">

          <tr class="header-measures">
          
            <th class="text-center" :colspan="sizes.length+4" style="background_:#f8f9fa; font-weight:bold;" > 

               <h4><strong>REGISTRAZIONE ORDINE VARIANTI PRODOTTO</strong></h4>
        
              <!-- PRODUCT INFO -->
              <product-info v-bind:productId="product.productId"></product-info> 

            </th>            
          
          </tr>

          <tr v-if="sizes.length > 0" class="header-measures">
            <th></th> <th></th> <th></th>                                  
            <th  class="text-center" :colspan="sizes.length " style="background_:#f8f9fa; font-weight:bold;" > MISURE </th>            
            <th  :style="{ width:  'auto' }" class="text-right"></th>
          </tr>
          
          <tr>
                <th  :style="{ width:  'auto' }">RIGA</th>
                <th  :style="{ width:  'auto' }" class="sticky-col_ sticky-color_">COLORE</th>
                <th  :style="{ width:  'auto' }"class="sticky-col_ sticky-desc_">COLORE FORNITORE</th>

            <th v-for="(size, sIndex) in sizes" :key="size.sizeId" class="text-center sticky-col" :style="{ width:  'auto_' }">
              {{ size.size }}
              <button v-if="false" class="btn btn-sm btn-danger ml-1" @click="removeSize(sIndex)"></button>
            </th>

            <th :style="{ width:  'auto' }" class="text-right">TOTALE</th>
          </tr>
        </thead>

        <tbody>

          <tr v-for="(variant, vIndex) in variants" :key="vIndex" :class="{ 'row-zero': isRowAllZero(variant) }">          



           

            <td class="sticky-col sticky-color">
                  <div class="d-flex align-items-center">

                    <!-- Bottone -->
                    <button
                      title="Elimina riga"
                      class="btn btn-light btn-sm d-flex align-items-center"
                      type="button"
                      @click="removeVariant(vIndex)"
                    >
                      <i class="fas fa-trash-alt" ></i>
                    </button>

                    <!-- Numero riga -->
                    <span class="ml-2">{{ vIndex + 1 }}</span>

                  </div>
          </td>



          <td  class="sticky-col sticky-color">
            
            <div class="input-group input-group-sm align-items-stretch">
            
         

              <!-- vSELECT COLOR  -->
              <v-select-colors 
              :required="true"  
              :key="variant.colorId + '-color'"   
              v-bind:Id="variant.colorId" 
              v-bind:vIndex="vIndex" 
              v-bind:variants="variants" 
              class="flex-grow-1" 
              @update="setColor"
              @setColors="setColors"
              :colors="colors"
              >
              
              </v-select-colors>              

            </div>
          </td>
            
          <td  class="sticky-col sticky-desc">
              <div class="input-group input-group-sm align-items-stretch">

                  <input
                      :ref = "'supplierColor-' +  vIndex" 
                      
                      type="text"
                      class="form-control form-control-sm"
                      v-model="variant.supplierColor"
                      placeholder="Inserisci colore fornitore"
                    />
                <div class="input-group-prepend">
                        <button v-if="vIndex==0"
                        type = 'button'
                        title = 'Replica quantità su tutte le righe ordine'
                        class="btn btn-light" 
                        :disabled="variants.length < 2" 
                        @click="replicateFirstRowQuantities()"
                      >
                      <i style="color:blueviolet" class="far fa-clone" aria-hidden="true"></i>  
                    </button>
                </div>
              </div>
          </td>
          <td v-for="(size, sIndex) in sizes" :key="size.sizeId" class="text-center qty-cell" :class="{ 'qty-zoomed_': activeRow === vIndex }">
                          
                <input :min="0"  :max="1000"                                  
                required
                type="number"

                class="form-control form-control-sm text-center input-full"
                v-model.number="variant.quantities[size.sizeId]"
                :ref="'qty-' + vIndex + '-' + sIndex"
               
                @focus="activeRow = vIndex"
                @blur="activeRow = null"

                />
                
              

              </td>

                  <!-- Totale riga -->
                  <td class="font-weight-bold text-right">
                    {{ totalPerRow(variant) }}
                  </td>

          </tr>
        </tbody>
        <tfoot>
          <tr class="font-weight-bold">

            <td></td>            
            <td class="align-middle">
              <button type="button" class="btn btn-sm btn-info" @click="addVariant">
               <i style="color:yellow" class='fas fa-indent mr-2'></i>
                AGGIUNGI RIGA
              </button>
            </td>
            
                        
            <td></td>

            <td  v-for="(size, sIndex) in sizes" :key="size.sizeId" class="text-center sticky-col" :style="{ width:  'auto' }">
              {{ size.size }}              
            </td>
            
            <td v-if="false" v-for="size in sizes" class="text-center" :key="size.sizeId">{{ totalPerSize(size) }}</td>
            <!--<td v-for="size in sizes" class="text-center" :key="size.sizeId"></td>-->
            <td class="text-right totalGeneral">{{ totalGeneral() }}</td> <!-- Totale generale di tutte le righe -->
          </tr>
        </tfoot>        
      </table>


    </div>
    
    
    
    <button :disabled="totaliGenerali.ordinato==0" type="submit"  class="btn btn-primary float-right mt-2 mr-4">
     <i class="fas fa-arrow-circle-right mr-2" aria-hidden="true"></i>
      PROCEDI
    </button>

</form>


    
    <div v-if="false">
      <h5 class="mb-4">Dati JSON:</h5>
      <pre> {{ product }} {{ variants }}</pre> 
      
    </div>
    
  </div>
</template>

<script>

import api                         from '@/api'
import productCollections          from '@/components/order/ProductCollections.vue'; 
import productInfo                 from '@/components/product/ProductInfo.vue';
import productSizeList             from '@/components/order/ProductSizeList.vue';
import sizesList                   from '@/components/order/SizesList.vue';
import VSelectColors               from '@/components/order/vSelectColors.vue';
import modalNewColor               from '@/components/order/NewColorForm.vue';
import EAN                         from "@/utils/index.js";
import { mapGetters }              from 'vuex'

import modalMessage                from '@/components/modalDialog/ModalMessage.vue'         
import modalConfirm                from '@/components/modalDialog/ModalConfirm.vue'


export default {
   props : ['product'],
   components: {productInfo,productSizeList,sizesList,VSelectColors,modalNewColor,productCollections,modalMessage,modalConfirm},
  data() {
    return {

      refresh    : false,       
      sizes      : [],      
      variants   : [],      
      activeRow  : null,
      msg        : '',
      colors     : []
      
    };
  },
   created () 
    {
      
      this.getData()
      
    },

computed: {

  ...mapGetters(['company']) ,  
  
  isSubmitDisabled() {
  return (
    this.variants.length === 0 ||
    this.variants.every(v =>
      Object.values(v.quantities).every(q => q === 0)
    )
  );
},

totaliGenerali() 
{ 
  let totaleOrdinato = 0; 
  
  this.variants.forEach(item => { 
    const ordinato = item.quantities;     
    const sommaOrdinato = Object.values(ordinato).reduce((a, b) => a + Number(b), 0);     
    totaleOrdinato += sommaOrdinato; 
    
  }); 
    return { ordinato: totaleOrdinato }; 
  }

},

  methods: {
    
    setColors(colors)
    {
      this.colors = colors
    },
    async getData()
    {
        this.spinner   = true
        const payload  = {'companyId':this.company.Id}
        const sp       = {'sp'      : 'spColorListNew'}
        const json     = Object.assign(payload, sp);

        
        await api.post(json).then(res => {
          if(res.status==200)
            {
                            
                this.colors          = res.data.recordsets[0]
                          
            }
            else if(res.status==500)
            {
             
              /*
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res.data
              this.msg.type = 1
              */

            } 
            else
            {
              /*
              this.msg.title = 'ATTENZIONE '
              this.msg.body = res
              this.msg.type = 1                 
              */
            } 
        }).catch(err => 
        {
          /*
          this.msg.title = 'ATTENZIONE '
          this.msg.body = err.message
          this.msg.type = 1  
          */
        }).finally(() => {
          this.spinner = false
        });

       
    },

    getProductEAN13(productId, colorId, sizeId) {
      const item = this.product.barcodes.find(
      b =>
      b.productId == productId &&
      b.colorId == colorId &&
      b.sizeId == sizeId
     );

       return item ? item.barcode : '';
    },

   
    generateAllBarcodes(productId,counter) {
        let r = counter
        this.variants.forEach(variant => {
          if (!variant.barcodes) {
            this.$set(variant, "barcodes", {});
          }

          Object.keys(variant.quantities).forEach(sizeId => {

              const ean13   =  this.getProductEAN13(
              productId,
              variant.colorId,
              sizeId   // <-- QUI la chiave è il sizeId

            )

                      
            const barcode = ean13.length == 13 ? ean13 : EAN.createEAN13(productId,++r)  
            this.$set(variant.barcodes, sizeId, barcode);
          });
      })
      
      return r
    },



    isRowAllZero(variant) {
      const quantities = variant.quantities;
      return Object.values(quantities).every(q => Number(q) === 0);
    },
    
    

    async submit() {

      let righeZero       = []
      // let coloreFornitore = []

      this.variants.forEach((variant, index) => {
        if (this.isRowAllZero(variant)) {
          righeZero.push(index);
        }

      });

      if (righeZero.length > 0) {

          const righe = righeZero.map(i => i + 1).join(", ")
          this.msg =  "QUANTITA' NON INSERITA ALLA RIGA  " + righe + ' .'

          await this.$refs.msgModal.show(this.msg,{},1)
                  
        return;
      }

      const counter =  this.generateAllBarcodes(this.product.productId,this.product.counter);
      this.$emit('update',this.variants,this.sizes,counter)
    
  },



    sanitizeQuantity(variant, sizeId) {

        let value = variant.quantities[sizeId];
        // rimuove tutto ciò che non è numero
        value = String(value).replace(/\D+/g, '');
        this.$set(variant.quantities, sizeId, value ? Number(value) : 0);

    },
    setColor(colorId,vIndex)
    {      
      this.variants[vIndex].colorId = colorId
      this.focusSupplierColor(vIndex)
    },
    setSizes(sizes)
    {
      this.sizes = sizes
      const  updateQuantitiesFromSizes = (variant, sizes) => {
        const newQuantities = {};

            sizes.forEach(size => {
          
              newQuantities[size.sizeId] =
              variant.quantities && variant.quantities[size.sizeId] !== undefined
                ? variant.quantities[size.sizeId]
                : 0;
              
          });
          
        // sostituzione completa → reattiva in Vue 2
        this.$set(variant, 'quantities', newQuantities);
      }
 
      this.variants.forEach(variant => {
        updateQuantitiesFromSizes(variant, this.sizes);
      });

    },
    setProductSizesList(productSizesList)
    {
      
       
        this.sizes = productSizesList
        this.refresh = true      
        this.addVariant()
        
      
                  

    },
    onColorSelect(vIndex) {
    const variant = this.variants[vIndex]

    // focus automatico sulla prima misura
    this.focusFirstQuantity(vIndex)
  },  


     totalPerRow(variant) {
       
         return Object.values(variant.quantities).reduce((sum, q) => sum + (q || 0), 0);
         
      },
      /*
      totalPerSize(size) {
          return this.variants.reduce((sum, v) => sum + (v.quantities[size] || 0), 0);
      },
      */
      totalGeneral() {
        return this.variants.reduce((sum, v) => sum + this.totalPerRow(v), 0);
      },
    
      
    focusSupplierColor(rowIndex) {
    this.$nextTick(() => {
      //if (this.sizes.length === 0) return;

      const refName = 'supplierColor-' + rowIndex ;
      const ref = this.$refs[refName];

      // Vue 2.6: $refs può essere un array se ref è dentro v-for
      const input = Array.isArray(ref) ? ref[0] : ref;

      if (input && input.focus) input.focus();
    });
    },
  

    focusFirstQuantity(rowIndex) {
    this.$nextTick(() => {
      if (this.sizes.length === 0) return;

      const refName = 'qty-' + rowIndex + '-0';
      const ref = this.$refs[refName];

      // Vue 2.6: $refs può essere un array se ref è dentro v-for
      const input = Array.isArray(ref) ? ref[0] : ref;

      if (input && input.focus) input.focus();
    });
    },

    /*
    availableColors(vIndex) {
      const usedIds = this.variants
        .filter((v, i) => i !== vIndex && v.colorId !== null)
        .map(v => v.colorId)
        return this.colors.filter(c => !usedIds.includes(c.id))
    },
    */
  createEmptyVariant() {
  return {
    
    colorId          : null,
    supplierColor    : '',
    quantities       : this.sizes.reduce((acc, s) => {
      acc[s.sizeId] = 0;
      return acc;
    }, {})
    }
    },

    addVariant() {
      
      this.variants.push(this.createEmptyVariant());
    },
    removeVariant(index) {
      console.log('VAriant',index)
      this.variants.splice(index, 1);
      //this.selectKey++
    },

    
    
    validateQuantity(variant, size) {
      if (variant.quantities[size] < 0) variant.quantities[size] = 0;
    },

    fillColumn(size, value) {
      this.variants.forEach(variant => {
        this.$set(variant.quantities, size, value);
      });
    },

    
    replicateFirstRowQuantities() {
        if (!this.variants.length) return;

        const sourceQuantities = this.variants[0].quantities;

        this.variants.forEach((variant, index) => {
          if (index === 0) return;

          // copia PROFONDA + reattiva
          this.$set(variant, 'quantities', { ...sourceQuantities });
        });
    },


  
    /*
    totalPerSize(size) {
      return this.variants.reduce((sum, v) => sum + (v.quantities[size] || 0), 0);
    },
    */
  },
};
</script>

<style scoped>

.qty-cell {
  transition: all 0.2s ease;
}

.qty-zoomed input {
  font-size: 1.2rem;
  height: 38px;
  font-weight: 600;
}

.qty-zoomed {
  background: #fff;
}


.page-header {
  position: fixed;
  top: 50;
  left: 0;
  width: 100%;
  z-index: 1000; /* sopra Bootstrap navbar/table */
  background-color: #fff;
}

/* header */
thead th.sticky-col {
  z-index: 20;
  background: #28a745;
  color: white;
  border-color: white !important;
  border-top: 2px solid #28a745 !important; 
  border-bottom: 2px solid #28a745 !important;
  
  padding-top       : 6px; /* distanza dal bordo superiore */ 
  padding-bottom    : 6px; /* distanza dal bordo inferiore */ 
  padding-left      : 8px; /* opzionale */ 
  padding-right     : 8px; /* opzionale */

}



/* footer */
tfoot td.sticky-col {
  z-index: 20;
  color : white;
  background: #28a745;
  border-color: white !important;
   border-top: 2px solid #28a745 !important; 
  border-bottom: 2px solid #28a745 !important;
}

/* celle normali */
tbody td {
  background: #fff;
}

.totalGeneral{
  
  background-color: gainsboro;
  color:blue
  
}

.vs__dropdown-menu {
  z-index: 1050; /* sopra Bootstrap modals */
}

button:hover {
   cursor        : pointer;
  }
.row-zero {
  background-color: #ffe6e6 !important;
}

.my-table,
.my-table th, 
.my-table td
{
  border-color: #28a745 !important;
}

/*
.td-input 
{
  padding: 0 !important; 
}
*/

.input-full {
 /*
  width: 100%;
  height: 100%;
  border: none;
  border-radius: 0;
  box-shadow: none;
  */
  font-weight       : bold;  
}

.input-full:focus {
  outline: none;
  border: 3px solid #2846a7 !important;
  --box-shadow: 0 0 0 2px rgba(0,123,255,.25) !important;
}


.td-input:focus-within {
  box-shadow: inset 0 0 0 3px #28a745;
}

.badge-pill
{
  font-size: large;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.fa-trash-alt{
  color: #28a745 !important;
  font-size: 18px;
}
</style>
